
import React from 'react';
import { LocalizedContent } from '../utils/localization';

interface ProductShowcaseProps {
  content: LocalizedContent;
}

const ProductShowcase: React.FC<ProductShowcaseProps> = ({ content }) => {
  return (
    <section className="py-12 bg-[#0F1015]">
      <div className="container mx-auto px-4">
        <div className="max-w-5xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-center">
            <div className="bg-black/40 p-1 rounded-lg shadow-xl shadow-purple-900/10 overflow-hidden">
              <div style={{ position: 'relative', width: '100%', height: '0px', paddingBottom: '62.718%' }}>
                <iframe 
                  src="https://streamable.com/e/6j3sfk?autoplay=1&nocontrols=1&muted=1&loop=1" 
                  allow="fullscreen;autoplay" 
                  allowFullScreen
                  style={{ border: 'none', width: '100%', height: '100%', position: 'absolute', left: '0px', top: '0px', overflow: 'hidden' }}
                  title="Product Video Example"
                ></iframe>
              </div>
            </div>
            <div>
              <h2 className="text-2xl font-bold mb-4 text-white font-future">{content.productShowcaseTitle}</h2>
              <p className="text-gray-300 mb-4">
                {content.productShowcaseText}
              </p>
              <ul className="space-y-3">
                {content.benefitPoints.map((point, index) => (
                  <li key={index} className="flex items-start">
                    <span className="text-purple-400 mr-2">✓</span>
                    <span className="text-gray-300">{point}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProductShowcase;
